import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import './index.css'

// PrimeVue
import PrimeVue from "primevue/config";
import Aura from '@primevue/themes/aura';
// PrimeVue Icons
import "primeicons/primeicons.css"; 

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(fas);
library.add(fab);
library.add(far);

// App configuration
const app = createApp(App)
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      dark: false // Desactiva el modo oscuro
    }      
  }
});
app.component("font-awesome-icon", FontAwesomeIcon);
app.mount("#app");


// Crear una nueva instancia para el catálogo (solo en el contenedor #vue-catalogo)
/*import CatalogoView from "@/components/views/CatalogoView.vue";
const appCatalogo = createApp(CatalogoView, {
  propsData: { id: 74 }
});
appCatalogo.use(PrimeVue, {
  theme: {
      preset: Aura
  }
});
appCatalogo.component("font-awesome-icon", FontAwesomeIcon);

appCatalogo.use(router);
appCatalogo.mount("#vue-catalogo");
*/